// extracted by mini-css-extract-plugin
module.exports = {"support":"support_support__RIlX6","submenu":"support_submenu__NY1CP","on":"support_on__x3JfK"};